import { render, staticRenderFns } from "./MfCard.vue?vue&type=template&id=98ac7348&scoped=true&"
import script from "./MfCard.vue?vue&type=script&lang=js&"
export * from "./MfCard.vue?vue&type=script&lang=js&"
import style0 from "./MfCard.vue?vue&type=style&index=0&id=98ac7348&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98ac7348",
  null
  
)

export default component.exports